import React, { useState, useRef } from 'react';
import { Input, Button } from 'antd';
import { SendOutlined } from '@ant-design/icons';
import { useApp } from '../../contexts/AppContext';
import './ChatInput.css';

const ChatInput: React.FC = () => {
  const [message, setMessage] = useState('');
  const { sendChatbotMessage, state } = useApp();
  const inputRef = useRef<any>(null);

  const handleSubmit = async () => {
    if (message.trim()) {
      await sendChatbotMessage(message.trim());
      setMessage('');
      // Focus the input after sending message
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }, 100);
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <div className="chat-input-container">
      <Input
        ref={inputRef}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        onKeyPress={handleKeyPress}
        placeholder="Type your message..."
        className="chat-input"
        disabled={state.isProcessing}
        size="large"
      />
      <Button
        type="primary"
        icon={<SendOutlined />}
        onClick={handleSubmit}
        disabled={!message.trim() || state.isProcessing}
        className="send-button"
        size="large"
      />
    </div>
  );
};

export default ChatInput;
